import { createHandlerChainRunner, Handler, HasOnError, HasOnSuccess } from "@insite/client-framework/HandlerCreator";
import { GETChatExpertImage } from "@tCentro/Services/CENChatExpertImageAPI";

type Parameter = HasOnSuccess<string> & HasOnError<string>;

type Props = {
    apiParameter: any;
    apiResult: any;
    error?: unknown;
};

type HandlerType = Handler<Parameter, Props>;

export const PopulateApiParameter: HandlerType = (props: { apiParameter: any; parameter: any; }) => {
    props.apiParameter = props.parameter;
};

export const RequestDataFromApi: HandlerType = async props => {
    props.apiResult = await GETChatExpertImage();
};

export const ExecuteOnSuccessCallback: HandlerType = props => {
    console.log('props.apiResult::',props.apiResult)
    if (props.apiResult.successful) {
        props.parameter.onSuccess?.(`{"imageUrl" : "${props.apiResult.result.imageUrl}"}`);
    }
};

export const ExecuteOnErrorCallback: HandlerType = props => {
    if (!props.apiResult.successful) {
        props.parameter.onError?.(props.apiResult.errorMessage);
    }
};

export const chain = [PopulateApiParameter, RequestDataFromApi, ExecuteOnSuccessCallback, ExecuteOnErrorCallback];

const ChatExpertImageHandler = createHandlerChainRunner(chain, "chatExpertImageHandler");
export default ChatExpertImageHandler;
